import React, { Fragment, useCallback, useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { Col } from "reactstrap";
import { useSpecificationContextState } from "./useSpecificationContextState";
import { useSpecificationContextUpdater } from "./useSpecificationContextUpdater";
import _ from 'lodash';
import usePreviousHook from "./usePreviousHook";

export default function SpecSelectWrapper({ onChangeString, optionsPRP }) {
  const [displayValue, setDisplayValue] = useState(null);
  const SpecContextState = useSpecificationContextState();
  const SpecUpdater = useSpecificationContextUpdater();

  let disable = false;
  if (!optionsPRP || !optionsPRP.length) {
    disable = true;
    toast.info(
      `The ${onChangeString} list is missing and therefore your ${onChangeString} drop down is disabled`
    );
  }
  let value = SpecContextState.specification[onChangeString];
  if (!value) value = { label: "--- Select ---", value: "--- Select ---" };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const renderDisplayValue = useCallback(() => {
    "does this run on init";
    if(!value || !optionsPRP || !optionsPRP.length) return;
    setDisplayValue(
      _.find(optionsPRP, x => x.value === value)
    );
  });

  const prevValu = usePreviousHook(value);

  useEffect(() => {
    if (disable) return;
    if (
      _.isEqual(value, { label: "--- Select ---", value: "--- Select ---" })
    ) {
      if(_.isEqual(prevValu, value)) return;
      setDisplayValue(value);
      return;
    }

    renderDisplayValue();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onSelectChange = (opt) => {
    if (opt && opt.value) {
      SpecUpdater.onChange(onChangeString, opt.value);
    }
  };

  return (
    <Fragment>
      {displayValue && (
        <Col xs="2">
          <Select
            id={onChangeString}
            classNamePrefix="serviceThreadSelect"
            value={displayValue}
            options={optionsPRP}
            isDisabled={disable}
            onChange={(opt) => onSelectChange(opt)}
          />
        </Col>
      )}
    </Fragment>
  );
}
